
export interface Partial<T> {
  part: number,
  partSize: number,
  items: T[];
}

export interface PartialSort {
  field: string,
  direction?: string
}

export class PartialParams {
  public part: number = 1;            //Part user is currently on
  public partSize: number = 25;       //Items displayed per part
  public offset: number = 0;          // Offset the page start if needed
  public sortBy: Array<PartialSort>;  //Column to sort items by

  constructor(partial?: Partial<any>) {
    if (partial) {
      this.part = partial.part
      this.partSize = partial.partSize;
    }
  }

  public getOrder(): string {
    if (this.sortBy.length > 1) {
      let orderCols = this.sortBy.map(list => { return list.field + '_' + (list.direction ?? 'asc') }).join(',');
      return orderCols;
    } else {
      return this.sortBy[0]?.field ?? 'id' + '_' + (this.sortBy[0]?.direction ?? 'asc');
    }
  }
}
